import React from 'react'

import { Text } from '.'
import { FormattedMessage } from 'react-intl'

export function LookingToJoin({ superEnabled }: { superEnabled: boolean }) {
  return (
    <Text.Corpus className="padding-vertical-16 shade-20">
      <FormattedMessage
        id="boarding.createOrganization.lookingToJoin"
        defaultMessage="Looking to <link>join an existing team</link>?"
        values={{
          link: (text: React.ReactNode) => (
            <Text.ExternalLink
              inline
              to={
                superEnabled
                  ? '/organization/super/select'
                  : '/organization/select'
              }
            >
              {text}
            </Text.ExternalLink>
          ),
        }}
      />
    </Text.Corpus>
  )
}
